export default __webpack_public_path__ + "static/media/salata.05efd5d8.svg";